import { render, staticRenderFns } from "./StateTypeDialogDataTabComponent.vue?vue&type=template&id=c2b58c54&scoped=true"
import script from "./StateTypeDialogDataTabComponent.js?vue&type=script&lang=js&external"
export * from "./StateTypeDialogDataTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./StateTypeDialogDataTabComponent.vue?vue&type=style&index=0&id=c2b58c54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b58c54",
  null
  
)

export default component.exports